import { useState } from "react";
import { Header } from "./components/Header";
import { StepsContent } from "./components/StepsContent";
import { useParams } from "react-router";
import "./styles.scss";

export const UserPayment = () => {
  const [step, setStep] = useState<number>(1);

  const { accountId } = useParams();

  return (
    <>
      <Header step={step} />
      <StepsContent step={step} accountId={accountId} setStep={setStep} />
    </>
  );
};
